import { memo } from 'react';

import { merge } from '@/components';
import { Badge, Button, ButtonProps, Text } from '@/components/core';
import { ExportLogo } from '@/components/logos';
import { JSONType, OmitChildren } from '@/utils';

export type ExportOption = {
  functionId: string;
  config: JSONType | (() => JSONType);
  name: string;
  description?: string;
  badge?: string;
  isFakeExport?: boolean;
};

export type ExportCellProps = OmitChildren<ButtonProps> & {
  option: ExportOption;
};

const IExportCell = ({ option, className, ...rest }: ExportCellProps) => {
  return (
    <Button className={merge('w-full !justify-start', className)} {...rest}>
      <ExportLogo size="xl" functionId={option.functionId} />
      <div className="flex flex-col items-start">
        <Text>{option.name}</Text>
        <Text className="!font-regular text-start !text-gray-500" size="xs">
          {option.description}
        </Text>
      </div>
      {option.badge ? (
        <>
          <div className="grow" />
          <Badge variant="default" label={option.badge} />
        </>
      ) : null}
    </Button>
  );
};

export const ExportCell = memo(IExportCell) as typeof IExportCell;
